 

import React, { useEffect, useState } from 'react';
 import { Link, useNavigate } from 'react-router-dom'; 
import Layout from '../components/Layout';
 import folder2 from '../assets/folder3.jpeg';
import axios from '../axios';
import { toast } from 'react-toastify';
import { useAuth } from '../context/AuthContext'; 

export default function Dashboard() {
  const [folders, setFolders] = useState([]);
  const [folderName, setFolderName] = useState('');
  const [subfolderName, setSubfolderName] = useState(''); 
  const [showConfirm, setShowConfirm] = useState(false); 
  const [editingName, setEditingName] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  const fetchFolders = async () => {
    try {
      const response = await axios.get('/folders');
      setFolders(response.data);
    } catch (err) {
      toast.error('Failed to load folders');
    }
  };

  useEffect(() => {
    fetchFolders();
  }, []);

 
  return (
    <Layout>
      <div className="container dashboard-contain">
      <h2>User Section - Folders</h2>
      <div className='dashboard-wrap '>  
      
         <ul className="list-unstyled">
         
                    {folders.map((folder, index) => (
                  
                     <li className="mb-2">
                       <img src={folder2}  className='side-folder'/>
                      <Link to={"/folders/"+folder.id} >{folder.name}</Link>
                       
                     </li>  
                    ))} 
                   
                 </ul>
        </div>  

        </div>

       
    </Layout>
  );
}
